import { Component, ContentChildren, QueryList, AfterContentInit, Input } from '@angular/core';

import { TabComponent } from './tab.component';

@Component({
  selector: 'tabs',
  styleUrls: ['./tabs.component.scss'],
  template: `
    <ul class="nav nav-tabs">
      <li *ngFor="let tab of tabs" (click)="selectTab(tab)" [class.active]="tab.active">
        <a>{{tab.title}}</a>
      </li>
    </ul>
    <ng-content></ng-content>
  `
})
export class TabsComponent implements AfterContentInit {
  @Input() initialActiveTab: number;

  @ContentChildren(TabComponent) tabs: QueryList<TabComponent>;

  // contentChildren are set
  ngAfterContentInit() {
    this.tabs.filter(tab => tab.active);
    if (Number.isInteger(this.initialActiveTab) && this.tabs.toArray()[this.initialActiveTab]) {
      return this.selectTab(this.tabs.toArray()[this.initialActiveTab]);
    }
    // get all active tabs
    const activeTabs = this.tabs.filter(tab => tab.active);

    // if there is no active tab set, activate the first
    if (activeTabs.length === 0) {
      this.selectTab(this.tabs.first);
    }
  }

  selectTab(tab: TabComponent) {
    // deactivate all tabs
    this.tabs.toArray().forEach(singleTab => (singleTab.active = false));

    // activate the tab the user has clicked on.
    tab.active = true;
  }
}
